import { format } from "date-fns";
import { get_all_recordings } from "../../api";
import { parseUtcDate } from "../../utils";
import { useKeyedRequest } from "../../utils/useKeyedRequest";

/** Fetch the visible months independently of the selected range, so nearby activity stays visible. */
export function useCalendarActivity(userIds: string[] | undefined, from: string, to: string) {
  const peopleKey = userIds === undefined ? "" : [...new Set(userIds)].sort().join(",");
  const { data, loading, failed } = useKeyedRequest(
    peopleKey ? JSON.stringify([peopleKey, from, to]) : null,
    async () => {
      const { recordings } = await get_all_recordings({
        user_ids: peopleKey.split(","),
        datetime_gte: from,
        datetime_lte: to,
        include_in_processes: true,
      });
      const counts = new Map<string, number>();
      for (const recording of recordings) {
        const day = format(parseUtcDate(recording.date_started), "yyyy-MM-dd");
        counts.set(day, (counts.get(day) ?? 0) + 1);
      }
      return counts;
    },
  );
  return { counts: data ?? undefined, loading, failed };
}
